/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import EnvironmentModel from 'cio/models/environment';
import { AutoMergeOption } from 'cio/utils/components/self-serve-migration-modal';

interface SelfServeMigrationModalIdToMultiIdArgs {
  environment: EnvironmentModel;
  readOnly?: boolean;
  onClose: () => unknown;
  onStart: Task<unknown, any[]>;
  haveIdentifiersChanged: boolean;
  email: string;
  onMergeOptionChange: (value: AutoMergeOption) => unknown;
  mergeOption: AutoMergeOption;
}

enum Step {
  Validation = 'Validation',
  MergeRules = 'MergeRules',
  Review = 'Review',
}

export default class SelfServeMigrationModalIdToMultiId extends Component<SelfServeMigrationModalIdToMultiIdArgs> {
  readonly Step = Step;

  @tracked currentStep: Step = Step.Validation;
  @tracked confirmedValidation = false;

  get steps() {
    return [
      { label: 'Understand data validation', value: Step.Validation, disabled: false, valid: true },
      {
        label: 'Set merging rules',
        value: Step.MergeRules,
        disabled: !this.confirmedValidation,
        valid: this.confirmedValidation && this.args.mergeOption != null,
      },
      {
        label: 'Confirm and start',
        value: Step.Review,
        disabled: !this.confirmedValidation || this.args.mergeOption == null,
        valid: this.currentStep === Step.Review,
      },
    ];
  }

  @action
  goToStep(step: Step, evt: SubmitEvent) {
    evt.preventDefault();

    if (this.currentStep === Step.Validation) {
      this.confirmedValidation = true;
    }

    this.currentStep = step;
  }
}
